<template>
  <v-footer padless>
    <v-card tile class="text-center" style="background-color: rgba(229,243,252,0.5); ">
      <v-card-text>
        <v-btn
          v-for="(icon, i) in icons"
          :key="i"
          :href="icon.link"
          target="_blank"
          icon
        >
          <v-icon size="24px">{{ icon.text }}</v-icon>
        </v-btn>
      </v-card-text>

      <v-card-text class="pt-0">
        <a href="/policy.html">Политика конфиденциальности</a>
        <a href="/offer.html" class="pa-2">Публичная оферта</a>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-text>
        ООО «Налог-сервис» использует файлы cookie с целью персонализации сервисов и повышения удобства пользования веб-сайтом.
          <br>Если вы не хотите использовать файлы cookie, измените настройки браузера.
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<style scoped>
.v-card {
  width: 100%;
}
.theme--light.v-footer{
  background-color: rgba(229,243,252,0.5);
}
</style>

<script>
export default {
  data: () => ({
    icons: [

    ],
  }),
};
</script>
